export class AssociateCandidateQueryFilter {
    constructor() {
        this.workLocationIds = [];
        this.sponsorships = [];
        this.jobTypes = [];
        this.jobSubTypes = [];
        this.salary = null;
        this.salaryDuration = "PER_YEAR";
        this.rate = null;
        this.rateDuration = "PER_HOUR";
        this.salaryCurrency = "USD";
        this.rateCurrency = "USD";
        this.column = "updatedDate";
        this.sortDirection = "Desc";
        this.includeCandidatesWithNoAdditionalDetails = true;
        this.includeCandidatesMatchingMandatoryCriteria = false;
        this.requestSource = 'JOB_MATCH_SCORE';
    }
}
//# sourceMappingURL=associateCandidatesQueryFilter.js.map